import axios from 'axios'
import { baseApiUrl } from '../config/config'

export const validateAppleMerchant = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/apple/session/validate`, params)
    // console.log(res.data)
    return res.data.data
  } catch (err) {
    throw new Error(err)
    // return null
  }
}

export const sendApplePaymentToken = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/pay-with-apple`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}
